import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { TrustSafety } from "@/components/landing/TrustSafety";
import { AppShowcase } from "@/components/landing/AppShowcase";
import { Footer } from "@/components/landing/Footer";
import TermsPage from "@/components/landing/TermsPage";
import PrivacyPage from "@/components/landing/PrivacyPage";
import ContactPage from "@/components/landing/ContactPage";
import TrackPage from "@/components/landing/TrackPage";

import { AdminAuthProvider, useAdminAuth } from "@/admin/AdminAuth";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import UserManagement from "@/admin/UserManagement";
import PaymentsFinance from "@/admin/PaymentsFinance";
import CustomerSupport from "@/admin/CustomerSupport";
import RideManagement from "@/admin/RideManagement";
import Settings from "@/admin/Settings";
import Employees from "@/admin/Employees";
import AdminDash from "@/admin/AdminDash";
import FraudAlerts from "@/admin/FraudAlerts";
import CommunityManagement from "@/admin/CommunityManagement";
import Marketing from "@/admin/Marketing";
import ModulePlaceholder from "@/admin/ModulePlaceholder";
import SafetyCenter from "@/admin/SafetyCenter";
import FullReport from "@/admin/FullReport";

function Landing() {
  return (
    <div className="App" data-testid="saferide-landing">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <TrustSafety />
        <AppShowcase />
      </main>
      <Footer />
    </div>
  );
}

function SiteRoutes() {
  useLenis();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

// Landing page: super admins land on Admin Dash, employees on the Dashboard.
const RoleHome = () => {
  const { admin } = useAdminAuth();
  return admin?.role === "super_admin" ? <AdminDash /> : <Dashboard />;
};

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<RoleHome />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="payments" element={<PaymentsFinance />} />
            <Route path="support" element={<CustomerSupport />} />
            <Route path="rides" element={<RideManagement />} />
            <Route path="settings" element={<Settings />} />
            <Route path="employees" element={<Employees />} />
            <Route path="fraud-alerts" element={<FraudAlerts />} />
            <Route path="community" element={<CommunityManagement />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="m/safety-center" element={<SafetyCenter />} />
            <Route path="finance-report" element={<FullReport />} />
            <Route path="m/:slug" element={<ModulePlaceholder />} />
          </Route>
          <Route path="/track/:id" element={<TrackPage />} />
          <Route path="/*" element={<SiteRoutes />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
